$(document).ready(function(){
  // Show the first tab and hide the rest
  $('#tabs-nav li:first-child').addClass('active');
  $('.tab-content').hide();
  $('.tab-content:first').show();

  // Click function
  $('#tabs-nav li').click(function () {
    $('#tabs-nav li').removeClass('active');
    $(this).addClass('active');
    $('.tab-content').hide();

    var activeTab = $(this).find('a').attr('href');
    $(activeTab).fadeIn();
    return false;
  });

  var selcted_val = $('#tabs-nav li:first-child a').text();
  $('.mob_select').text(selcted_val);
  
  if(window.outerWidth < 991){
    $(document).on('click', '.mob_select', function(){
      $('#tabs-nav').slideToggle();
      $(this).toggleClass('arrow_rotate');
    });
    $('#tabs-nav li').click(function () {
      $(this).parents('#tabs-nav').slideUp();
      var selted_option = $(this).text();
      $('.mob_select').text(selted_option);
      
    });
  }


//   jQuery.getJSON('/products/uriage-bundle-ds-hair-shampoo-equilibrant-antipelliculaire.json', function(product) {
//     console.log(product);
//   alert('The title of this product is ' + product.title);
// });

  // Reorder Functionality
  $(document).on('click', '.view_order .reorder', function(){
    $(this).find('span.cstm_loader').removeClass('hide');
    var selected_products = [];
    $(this).parents('.order_details').find('.order_products .order_product').each(function(){
      var variant_id = $(this).attr('data-variant-id');
      var product_id = $(this).attr('data-product-id');
      
      selected_products.push(variant_id);
      for( var i=0; i < selected_products.length; i++){
        (function(i){
          setTimeout(function(){
            var single_product_data = selected_products[i];
            $.ajax({
              type: 'POST',
              url: '/cart/add.js',
              data:{
                id: single_product_data,
                quantity: 1
              },
              dataType: 'json',
              success: function(){ 
                var iteration_length = i + 1;
                if (iteration_length == selected_products.length) {
                  $('.order_product[data-product-id="'+ product_id +'"]').closest('.order_details').find('span.cstm_loader').addClass('hide');
                   window.location.href ='/cart';
                }
              },
              error: function() { 
                $('.order_product[data-product-id="'+ product_id +'"]').closest('.order_details').find('.error_msg').addClass('show_error');
                $('.order_product[data-product-id="'+ product_id +'"]').closest('.order_details').find('span.cstm_loader').addClass('hide');
                return;
              }
            });
          }, 1500 * i);
        }(i));
      }
   });
  });
});









/* Searchable A-Z Shop By Brand menu — Familialist */
(function () {
  function initBrandMenus() {
    document.querySelectorAll('[data-brand-menu]').forEach(function (menu) {
      if (menu.dataset.brandMenuReady === 'true') return;
      menu.dataset.brandMenuReady = 'true';

      var search = menu.querySelector('[data-brand-search]');
      var letterButtons = Array.prototype.slice.call(menu.querySelectorAll('[data-brand-letter]'));
      var items = Array.prototype.slice.call(menu.querySelectorAll('[data-brand-item]'));
      var empty = menu.querySelector('[data-brand-empty]');
      var activeLetter = 'all';

      function normalize(value) {
        return (value || '').toString().toLocaleLowerCase().trim();
      }

      function applyFilter() {
        var query = normalize(search ? search.value : '');
        var visibleCount = 0;

        items.forEach(function (item) {
          var name = normalize(item.getAttribute('data-brand-name'));
          var letter = normalize(item.getAttribute('data-brand-letter-value'));
          var matchesLetter = activeLetter === 'all' || letter === normalize(activeLetter);
          var matchesSearch = !query || name.indexOf(query) !== -1;
          var show = matchesLetter && matchesSearch;
          item.hidden = !show;
          if (show) visibleCount += 1;
        });

        if (empty) empty.hidden = visibleCount !== 0;
      }

      letterButtons.forEach(function (button) {
        button.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          activeLetter = button.getAttribute('data-brand-letter') || 'all';
          letterButtons.forEach(function (candidate) {
            var selected = candidate === button;
            candidate.classList.toggle('active', selected);
            candidate.setAttribute('aria-pressed', selected ? 'true' : 'false');
          });
          applyFilter();
          if (search) search.focus({ preventScroll: true });
        });
      });

      if (search) {
        search.addEventListener('input', function () {
          if (search.value && activeLetter !== 'all') {
            activeLetter = 'all';
            letterButtons.forEach(function (button) {
              var selected = button.getAttribute('data-brand-letter') === 'all';
              button.classList.toggle('active', selected);
              button.setAttribute('aria-pressed', selected ? 'true' : 'false');
            });
          }
          applyFilter();
        });
        search.addEventListener('click', function (event) { event.stopPropagation(); });
        search.addEventListener('keydown', function (event) { event.stopPropagation(); });
      }

      applyFilter();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBrandMenus);
  } else {
    initBrandMenus();
  }
})();

/* Product-description display normalization — presentation only.
   This changes the rendered DOM, never Shopify's stored description. */
(function () {
  var headingLabels = /^(?:indications?|how\s+to\s+use|directions?(?:\s+for\s+use)?|instructions?|usage|ingredients?|composition|benefits?|key\s+benefits?|features?|key\s+features?|recommended\s+use|familialist[’']s\s+recommendations?|warnings?|warning\s+of\s+usage|precautions?|dosage|storage|product\s+details?|mode\s+d['’]emploi|conseils?\s+d['’]utilisation|utilisation|ingr[ée]dients?|bienfaits?|avantages?|caract[ée]ristiques?|avertissements?|pr[ée]cautions?|posologie|recommandations?\s+(?:de\s+)?familialist)\s*[:;]?$/i;
  var richContentSelector = 'img, picture, video, audio, iframe, table, ul, ol, svg, canvas, model-viewer, hr, form, input, button, select, textarea, details, script, style, template';
  var nestedBlockSelector = 'div, p, blockquote, section, article, figure, table, ul, ol, form, details';
  var flowProtectedTags = {
    IMG: true,
    PICTURE: true,
    VIDEO: true,
    AUDIO: true,
    IFRAME: true,
    TABLE: true,
    SVG: true,
    CANVAS: true,
    'MODEL-VIEWER': true,
    FORM: true,
    INPUT: true,
    BUTTON: true,
    SELECT: true,
    TEXTAREA: true,
    DETAILS: true,
    SUMMARY: true,
    PRE: true,
    CODE: true,
    SCRIPT: true,
    STYLE: true,
    TEMPLATE: true
  };

  function forEachNode(nodes, callback) {
    Array.prototype.forEach.call(nodes, callback);
  }

  function cleanText(value) {
    return (value || '')
      .replace(/[\u00a0\u200b-\u200d\ufeff]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function hasProtectedMarker(element) {
    if (element.id) return true;

    var nodes = [element];
    Array.prototype.push.apply(nodes, element.querySelectorAll('*'));

    return nodes.some(function (node) {
      return Array.prototype.some.call(node.attributes || [], function (attribute) {
        return attribute.name.indexOf('data-') === 0 || attribute.name === 'contenteditable';
      });
    });
  }

  function isKnownStandaloneHeading(element) {
    var text = cleanText(element.textContent);
    if (!text || text.length > 80 || !headingLabels.test(text)) return false;
    if (element.querySelector('h1, h2, h3, h4, h5, h6')) return false;

    var nestedBlocks = element.querySelectorAll('p, div');
    var duplicateInChild = Array.prototype.some.call(nestedBlocks, function (child) {
      return child !== element && cleanText(child.textContent) === text;
    });

    return !duplicateInChild;
  }

  function normalizeHeadingPunctuation(element) {
    if (!/;\s*$/.test(cleanText(element.textContent))) return;

    var walker = element.ownerDocument.createTreeWalker(element, 4, null, false);
    var node;
    var lastTextNode = null;

    while ((node = walker.nextNode())) {
      if (cleanText(node.nodeValue)) lastTextNode = node;
    }

    if (lastTextNode) {
      lastTextNode.nodeValue = lastTextNode.nodeValue.replace(/;(\s*)$/, ':$1');
    }
  }

  function normalizeFlow(element) {
    if (!element || flowProtectedTags[element.tagName]) return;

    var inlineStyle = element.getAttribute('style') || '';
    var hasInlineConstraint = /(?:^|;)\s*(?:height|min-height|max-height|overflow|overflow-x|overflow-y)\s*:/i.test(inlineStyle);
    var computedStyle = window.getComputedStyle ? window.getComputedStyle(element) : null;
    var computedOverflow = computedStyle
      ? [computedStyle.overflow, computedStyle.overflowX, computedStyle.overflowY].join(' ')
      : '';
    var hasScrollOverflow = /\b(?:auto|scroll|overlay)\b/i.test(computedOverflow);

    if (hasInlineConstraint || hasScrollOverflow) {
      element.classList.add('familialist-description-flow-reset');
      element.style.setProperty('height', 'auto', 'important');
      element.style.setProperty('min-height', '0', 'important');
      element.style.setProperty('max-height', 'none', 'important');
      element.style.setProperty('overflow', 'visible', 'important');
      element.style.setProperty('overflow-x', 'visible', 'important');
      element.style.setProperty('overflow-y', 'visible', 'important');
    }
  }

  function normalizeDescription(root) {
    if (!root || root.getAttribute('data-familialist-description-ready') === 'true') return;
    root.setAttribute('data-familialist-description-ready', 'true');

    normalizeFlow(root);
    forEachNode(root.querySelectorAll('*'), normalizeFlow);

    forEachNode(root.querySelectorAll('p, div'), function (element) {
      var text = cleanText(element.textContent);
      var hasRichContent = Boolean(element.querySelector(richContentSelector));

      if (!text && !hasRichContent && !hasProtectedMarker(element)) {
        element.classList.add('familialist-description-empty');
        element.hidden = true;
        return;
      }

      if (element.tagName === 'DIV' && text && !hasRichContent && !element.querySelector(nestedBlockSelector)) {
        element.classList.add('familialist-description-text-block');
      }
    });

    forEachNode(root.querySelectorAll('h1, h2, h3, h4, h5, h6'), function (heading) {
      normalizeHeadingPunctuation(heading);
      heading.classList.add('familialist-description-heading');
    });

    forEachNode(root.querySelectorAll('p, div'), function (candidate) {
      if (isKnownStandaloneHeading(candidate)) {
        normalizeHeadingPunctuation(candidate);
        candidate.classList.add('familialist-description-heading');
      }
    });

    /* Handle a rare description that places a label directly in an inline
       element without a surrounding paragraph or div. */
    forEachNode(root.querySelectorAll('span, strong, b'), function (candidate) {
      var parent = candidate.parentElement;
      if (parent === root && isKnownStandaloneHeading(candidate)) {
        normalizeHeadingPunctuation(candidate);
        candidate.classList.add('familialist-description-heading');
      }
    });

    var firstHeading = root.querySelector('.familialist-description-heading');
    if (firstHeading) {
      firstHeading.classList.add('familialist-description-heading--first');
    }
  }

  function initProductDescriptions(scope) {
    var context = scope && scope.querySelectorAll ? scope : document;

    if (context.nodeType === 1 && context.hasAttribute('data-familialist-description')) {
      normalizeDescription(context);
    }

    forEachNode(context.querySelectorAll('[data-familialist-description]'), normalizeDescription);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initProductDescriptions(document);
    });
  } else {
    initProductDescriptions(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initProductDescriptions(event.target);
  });
})();



/* Familialist product page: purchase action visible before the long mobile gallery ends. */
(function () {
  'use strict';

  function init() {
    if (!document.body.classList.contains('pageproduct') ||
        document.getElementById('familialist-mobile-buy-bar') ||
        document.querySelector('.tt-fixed-product-wrapper')) return;

    var mainButton = document.querySelector(
      '.product_page_template .tt-product-single-info form.shopify-product-form .btn-addtocart'
    );
    if (!mainButton) return;

    var mobile = window.matchMedia('(max-width: 575px)');
    var viewedOptions = false;
    var scheduled = false;
    var bar = document.createElement('div');
    var button = document.createElement('button');

    bar.id = 'familialist-mobile-buy-bar';
    bar.hidden = true;
    button.type = 'button';
    button.textContent = 'Add to cart';
    bar.appendChild(button);
    document.body.appendChild(bar);

    function optionArea() {
      return document.querySelector(
        '.product_page_template .tt-product-single-info .tt-swatches-container-js'
      );
    }

    function hasChoices(area) {
      if (!area) return false;
      var selects = area.querySelectorAll('select');
      for (var i = 0; i < selects.length; i++) {
        if (selects[i].options.length > 1) return true;
      }
      return !!area.querySelector('input[type="radio"], .tt-options-swatch li');
    }

    function choiceLabel(area) {
      var title = area && area.querySelector('.tt-title-options');
      var text = title && title.textContent.split(':')[0].trim();
      return text && text.length < 25 ? 'Choose ' + text.toLowerCase() : 'Choose options';
    }

    function update() {
      scheduled = false;
      var area = optionArea();
      var choices = hasChoices(area);
      var rect = mainButton.getBoundingClientRect();

      if (choices && area) {
        var optionsRect = area.getBoundingClientRect();
        if (optionsRect.top < window.innerHeight - 100 && optionsRect.bottom > 70) {
          viewedOptions = true;
        }
      }

      var mainVisible = rect.top < window.innerHeight - 80 && rect.bottom > 60;
      var available = !mainButton.disabled &&
        !mainButton.classList.contains('disable') &&
        !!mainButton.getClientRects().length;
      var show = mobile.matches && available && !mainVisible;

      button.textContent = choices && !viewedOptions
        ? choiceLabel(area)
        : (/pre.?order/i.test(mainButton.textContent) ? 'Pre-order' : 'Add to cart');
      bar.hidden = !show;
      document.body.classList.toggle('familialist-mobile-buy-visible', show);
    }

    function scheduleUpdate() {
      if (!scheduled) {
        scheduled = true;
        window.requestAnimationFrame(update);
      }
    }

    button.addEventListener('click', function () {
      var area = optionArea();
      if (hasChoices(area) &&
          (!viewedOptions || /select options|choose options/i.test(mainButton.textContent))) {
        area.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      if (!mainButton.disabled && !mainButton.classList.contains('disable')) {
        mainButton.click(); // Use the existing Wookie form, selected variant, and quantity.
      }
    });

    window.addEventListener('scroll', scheduleUpdate, { passive: true });
    window.addEventListener('resize', scheduleUpdate);
    document.addEventListener('change', scheduleUpdate);
    window.setTimeout(scheduleUpdate, 800); // Wookie creates variant controls after page load.
    update();
  }

  if (document.readyState === 'complete') init();
  else window.addEventListener('load', init, { once: true });
}());


